<div class="modal-header container-md" id="modal-header">
  <div class="col-4"></div>
  <div class="col-4">
    <img id="modal-memorabid-logo" src="/assets/img/memorabid-logo-white.svg" alt="MEMORABID">
  </div>
  <div class="col-3"></div>
  <div class="col-1">
    <button id="closeButton" type="button" class="close" aria-label="Close" (click)="dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>
<div class="modal-body mx-3">
  <div>
    <h3 class="text-uppercase">{{ 'IDS_NOTIFICATIONS' | translate }}</h3>
  </div>

  <div class="mt-3">
    <p class="mb-4">{{ 'IDS_ENABLE_NOTIFICATIONS_BODY' | translate }}</p>

    <div class="d-flex justify-content-center mt-2">
      <button type="button" class="btn-gold text-uppercase fw-bold px-3" (click)="allow()">
        {{ 'IDS_CONFIRM' | translate }}
      </button>
    </div>
    <div class="d-flex justify-content-center my-3">
      <button class="admin-new text-uppercase fw-bold px-3" type="button" (click)="dismiss()">
        {{ 'IDS_BTN_ABORT' | translate }}
      </button>
    </div>
  </div>
</div>
